export default groups => groups.map((g) => {
  if (g.field === 'locked_attributes') {
    return ({
      field: g.field,
      operator: g.operator,
    });
  } return g;
});
